class AccordionVideoHandler {
  constructor( sectionClass ) {
    this.sections = document.querySelectorAll( `.${sectionClass}` );
    if ( this.sections.length === 0 ) return;
    this.init();
  }

  init() {
    this.sections.forEach( ( section ) => {
      section.addEventListener( 'click', () => this.handleSectionClick( section ) );
    } );
  }

  handleSectionClick( section ) {
    const wrappers = section.parentNode.querySelectorAll( '.e-acc__flt-itm-wrpr' );

    wrappers.forEach( ( wrapper ) => {
      const video = wrapper.querySelector( 'iframe, video' );
      if ( !video ) return;

      if ( wrapper.classList.contains( 'active' ) ) {
        this.playVideo( video );
      } else {
        this.pauseVideo( video );
      }
    } );
  }

  playVideo( video ) {
    if ( video.tagName === 'VIDEO' ) {
      video.play();
    } else if ( video.tagName === 'IFRAME' ) {
      const src = video.getAttribute( 'src' );
      let newSrc = src;

      if ( src.includes( 'youtube.com' ) ) {
        newSrc = `${src.split( '?' )[0]}?enablejsapi=1&autoplay=1&mute=0&rel=0`;
      } else if ( src.includes( 'vimeo.com' ) ) {
        newSrc = `${src.split( '?' )[0]}?autoplay=1&muted=0`;
      } else if ( src.includes( 'wistia.com' ) ) {
        newSrc = `${src.split( '?' )[0]}?autoPlay=true&playbackMuted=false`;
      }

      if ( src !== newSrc ) {
        video.setAttribute( 'src', newSrc );
      }

      // Ensure the video starts by posting a play message
      setTimeout( () => {
        if ( src.includes( 'youtube.com' ) ) {
          video.contentWindow.postMessage(
            JSON.stringify( { event: 'command', func: 'playVideo' } ),
            'https://www.youtube.com'
          );
        } else if ( src.includes( 'wistia.com' ) ) {
          video.contentWindow.postMessage(
            JSON.stringify( { method: 'play' } ),
            'https://fast.wistia.com'
          );
        }
      }, 50 );
    }
  }

  pauseVideo( video ) {
    if ( video.tagName === 'VIDEO' ) {
      video.pause();
    } else if ( video.tagName === 'IFRAME' ) {
      const src = video.src;
      if ( src.includes( 'youtube.com' ) ) {
        video.contentWindow.postMessage(
          JSON.stringify( { event: 'command', func: 'pauseVideo' } ),
          'https://www.youtube.com'
        );
      } else if ( src.includes( 'vimeo.com' ) ) {
        video.contentWindow.postMessage(
          JSON.stringify( { method: 'pause' } ),
          'https://player.vimeo.com'
        );
      } else if ( src.includes( 'wistia.com' ) ) {
        video.contentWindow.postMessage(
          JSON.stringify( { method: 'pause' } ),
          'https://fast.wistia.com'
        );
      }
    }
  }
}

document.addEventListener( 'DOMContentLoaded', () => {
  new AccordionVideoHandler( 'e-stn--accordion-white' ); // NOSONAR
} );
